import React, { useContext } from 'react';
import './AppLogo.scss';
// @ts-ignore
import placeholder from '../../assets/icons/app-logo-placeholder.svg';
import HmiContext from '../../context/HmiContext';
import FormatMessage from '../../messages/FormatMessage';
import { hmiConfig } from '../../hmi.config';

type Props = {
  src: string;
  rating?: string;
  ratingPoints?: number;
};

const AppLogoRating: React.FC<Props> = props => {
  const hmiContext = useContext(HmiContext);
  const { parentApp } = hmiContext.hmi;

  return (
    <>
      {props.rating && (
        <>
          <div className="app-rating-wrapper">
            <div className={`app-rating`}>
              <span className="app-rating-highlighted">{props.rating}</span>
            </div>
            <div className={'app-rating-assured'}>
              <FormatMessage id={'hmi.rating.assured'} />
            </div>
          </div>

          <div className="app-details-header-headline">
            {parentApp?.info.name || ''}
          </div>
          <a
            href={hmiConfig.links.hatdexRating}
            target="_blank"
            className="app-link"
            rel="noopener noreferrer"
          >
            <FormatMessage id={'hmi.rating.learnMore'} />
          </a>
        </>
      )}
    </>
  );
};

const AppLogo: React.FC<Props> = props => {
  return (
    <div className={'app-logo-container'}>
      <div className="app-logo-wrapper">
        <img
          src={props.src || placeholder}
          alt={'Application logo'}
          className="img img-responsive app-logo"
        />
      </div>

      <AppLogoRating {...props} />
    </div>
  );
};

export default AppLogo;
